<div *ngFor="let dataGroup of chatdata.metadata;" class="row">

    <div *ngFor="let data of dataGroup| keys let i = index" class="col-6 display-grid m-b-15">
        <div>
            <div class="product-panel__bg1">
                <div class="product_panel">
                    <h4>{{data.name | slice:0:62}}{{data.name .length > 62 ? '...' : '' }}</h4>
                </div>
                <div class="product_panel_body">
                    <p class="p-b-10"
                        *ngIf="data.relative_path && data.relative_path !== '' && data.relative_path !== null">
                        <span>Path: {{data.relative_path}}</span>
                    </p>
                    <p class="p-b-10" *ngIf="data.page && data.page.length > 0">
                        <span>Page: {{removeDuplicatesAndJoin(data.page)}}</span>
                    </p>

                </div>
            </div>
        </div>
    </div>
</div>